export enum LookupKey {
    LOOKUP_URL = 'ListOfValues_REST/GetListOfValues',
    ACTIVITIES_URL = "ActivityCode_REST/ActivityCode",
    DC_LIC_TYPE = 'DC_LIC_TYPE',
    DC_LIC_AUTH = 'DC_LIC_AUTH',
    COUNTRY = 'COUNTRY',
    LEGAL_STATUS = 'XX_LEGAL_STATUS',
    FIRM_TYPE = "XX_FIRM_TYPE",
    RESPONSIBILITY = "RESPONSIBILITY",
    ACTIVITIES = "XX_CODE_ACTIVITIES",
    DC_SR_TYPE = "DC_SR_TYPE",
    SR_SUB_TYPE = "SR_SUB_TYPE",
    SR_STATUS = "SR_STATUS",
    SUBJECT = "DC_SVS_SUBJECT",
    COO_STAMP_TYP = "DC_SVS_COO_STAMP_TYP",
    INQUIRY_TYPE = "DC_INQUIRY_TYPE",
    DC_CONTACT_CATEGORY = "DC_CONTACT_CATEGORY",
    DISPUTE_TYPE = "DC_TYPE_OF_DISPUTE",
    CITY_CODES = "XX_CITY_CODES",
    DC_MEM_CANCEL_REASON = "DC_MEM_CANCEL_REASON",
    DC_RESIDENT_OF_UAE = "DC_RESIDENT_OF_UAE",
    XX_BANK_CODES = "XX_BANK_CODES",
    INTENDED_GOODS = "XX_INTENDED_GOODS",
    ENTRY_TYPE = "DC_VISIT_TRANSIT",
    MODE_OF_TRASNPORT = "DC_TRASNPORT",
    ATA_PROCESSING_TYPE = "X_ATA_PROC_TYPE",
    ATA_CARNET_COLLECTION_TYPE = "DC_COO_COLLECTION",
    EMIRATES_TYPE = "DC_EMIRATES_TYPE",
    ATA_BUSINESS_TYPE = "DC_PORTAL_BUSINESS_TYPE",
    UNIT_OF_MEASURE = "UNIT_OF_MEASURE",
    ATA_CARNET_COUNTRIES = "XX_ATA_CARNET_COUNTRIES",
    ATA_PRODUCT_CATEGORY = "XXATA_CATEGORY",
    ATA_NOC_LETTER_TYPE = "DC_NOC_LETTER_TYPE",
    ATA_CARNET_TYPE = "ATA_CARNET_TYPE",
    COO_DC_CONSGN_TYPE = "DC_CONSGN_TYPE",
    COO_DC_SHIPMENT_VALUE = "DC_SHIPMENT_VALUE",
    COO_DC_COO_EXIT_POINT = "DC_COO_EXIT_POINT",
    COO_DC_EXP_TYPE = "DC_EXP_TYPE",
    COO_DC_LANG = "DC_LANG",
    COO_DC_PORT_DISCHRG = "DC_PORT_DISCHRG",
    COO_DC_TRASNPORT = "DC_TRASNPORT",
    COO_DC_PROCESS_TYPE = "DC_PROCESS_TYPE",
    UNIT_OF_WEIGHT = "UNIT_OF_WEIGHT",
    COO_DC_PER_EFF_TYPE = "DC_PER_EFF_TYPE",
    COO_GSP_DC_COUNTRY = "DC_COUNTRY_ECOO",
    DC_PORTAL_APPLICANT_TYPE = "DC_PORTAL_APPLICANT_TYPE",
    PAYMENT_METHOD_CODE = "PAYMENT_METHOD_CODE",
    DC_ONLINE_PAY_TYPE = "DC_ONLINE_PAY_TYPE",
    DC_MEDIATION_REGISTRATION_FEE = "DC_MEDIATION_REGISTRATION_FEE",
    DC_MEDIATION_ADMINISTRATIVE_FE = "DC_MEDIATION_ADMINISTRATIVE_FE",
    PAYMENT_METHOD = "DC_PORTAL_PAY_METHOD",
    DC_RESTRICT_ADDN_COO_WORDS = "DC_RESTRICT_ADDN_COO_WORDS",
    DC_SVS_AUDITOR_EXCPTION = "DC_SVS_AUDITOR_EXCPTION",
    DC_USER_TYPE = "DC_USER_TYPE",
    DC_MEM_PACKAGE_TYPE = "DC_MEM_PACKAGE_TYPE",
    QUERY_PACKAGE_QUARTER = "QUERY_PACKAGE_QUARTER",
    DC_MRM_FEES = "DC_MRM_FEES",
    HLS_CASE_STATUS = "HLS_CASE_STATUS",
    DC_REPORT_PERIOD = "DC_REPORT_PERIOD",
    DC_SECTOR_INDUSTRY = "DC_SECTOR_INDUSTRY",
    DC_NUM_OF_EMP = "DC_NUM_OF_EMP",
    DC_BUSNS_PRIORITY = "DC_BUSNS_PRIORITY",
    DC_COMM_CHANNEL = "DC_COMM_CHANNEL",
    DC_DCE_TRAINING_WORKSHP = "DC_DCE_TRAINING_WORKSHP",
    DC_DCE_STRATEGIC_PROGRAMS = "DC_DCE_STRATEGIC_PROGRAMS",
    DC_DCE_ADDN_SERVICES = "DC_DCE_ADDN_SERVICES",
    DC_DCE_PARAMS = "DC_DCE_PARAMS",
    PLATINIUM_MEM_LIMIT="DC_PLATINIUM_MEM_LIMIT",
    AREA_CODES ="XX_AREA_CODES"
}
